<app-column-title [column]="column"></app-column-title>

<div (click)="onClick(column.link)">
  <span class="col-control-link">{{ getData }}</span>
</div>
